import { gql } from "graphql-request";

export const GET_ORGANIZATION_CONFIGS = gql`
  query GetOrganizationConfigs(
    $filter: String!
    $sort: String!
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getorganizationconfigs(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationIds
        Tags
        DeletedDate
        orgLogo
      }
    }
  }
`;

export const GET_ORGANIZATION_COLOR = gql`
  query GetOrganizationColor(
    $filter: String!
  ) {
    getorganizationconfigs(
      input: {
        filter: $filter
      }
    ) {
      items {
        primaryColor 
      }
    }
  }
`;

export const INSERT_ORGANIZATION_CONFIG = gql`
  mutation InsertOrganizationConfig(
    $orgLogo: String
    $organizationIds: [String]
  ) {
    insertorganizationconfig(
      input: { orgLogo: $orgLogo, OrganizationIds: $organizationIds }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_ORGANIZATION_CONFIG = gql`
  mutation UpdateOrganizationConfig($filter: String!, $orgLogo: String) {
    updateorganizationconfig(filter: $filter, input: { orgLogo: $orgLogo }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_ORGANIZATION_CONFIG = gql`
  mutation DeleteOrganizationConfig($filter: String!) {
    deleteorganizationconfig(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_ORGANIZATION_COLOR = gql`
  mutation UpdateOrganizationColor($filter: String!, $primaryColor: String) {
    updateorganizationconfig(filter: $filter, input: { primaryColor: $primaryColor }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

